module.exports = __webpack_public_path__ + "img/ag.886dd7a5.svg";